<template>
  <div>
    <div class="toolbar">
      <div class="toolbar__row">
        <div class="search-filter search-filter--narrow">
          <b-icon-search />
          <input
            v-model="searchInput"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t(toggleSearch === 'OrderNumber' ? 'OrderNumber' : 'ClientName')"
            @keydown.down="onArrowDown"
            @keydown.up="onArrowUp"
            @keydown.enter.prevent="selectHighlighted"
          >
          <b-icon-x-circle
            class="search-filter__clear"
            :class="{ 'search-filter__clear--active': searchClient != '' || searchOrderNumber != '' }"
            @click="searchClient = '', searchOrderNumber = ''"
          />
          <b-form-select
            v-model="toggleSearch"
            :options="searchFilterOptions"
          />
          <div
            v-if="filteredResults.length > 0"
            ref="scrollContainer"
            class="search-filter__options"
          >
            <div
              v-for="(result, index) in filteredResults"
              :key="index"
              ref="options"
              :class="{ 'is-active': index === arrowCounter }"
              class="search-filter__option"
              @click="selectResult(result)"
            >
              {{ displayResult(result) }}
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-3" style="width: 70%;">
          <StoresDropdown
            :filiale="store"
            @updateFiliale="updateFiliale"
            style="width:50%"
          />
          <b-form-group>
            <b-form-select
              v-model="selectedOrderType"
              :options="transformOrderTypes"
              class="custom-selected-input"
            />
          </b-form-group>
        </div>
      </div>
    </div>
    <div>
      <table
        class="team_table"
        style=""
      >
        <thead>
          <tr>
            <th>
              {{ $t('No') }}
            </th>
            <th>
              {{ $t('OrderNumber') }}
            </th>
            <th>
              {{ $t('OrderType') }}
            </th>
            <th>
              {{ $t('ClientName') }}
            </th>
            <th>
              {{ $t('StoreName') }}
            </th>
            <th>
              {{ $t('paidAmount') }}/{{ $t('Price') }}
            </th>
            <th>
              {{ $t('PhoneNumber') }}
            </th>
            <th>
              {{ $t('ShippingAddress') }}
            </th>
            <th>
              {{ $t('Created') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
        :is-loading="isRequestLoading('loadPartiallyOrders')"
        :responseData="getPartiallyDeliveredOrders"
        >
          <tr
            v-for="(item, index) in getPartiallyDeliveredOrders"
            :key="index"
            v-b-tooltip.hover
            v-b-toggle.order-details-id
            :title="$t('ClickToView')"
            style="cursor:pointer;"
            @click="loadOrderDetails(item.orderId, item)"
          >
            <td>
              {{ getTotalItemsPartiallyOrders-(pageNumber-1)*pageSize-index }}.
            </td>
            <td>
              {{ item.orderNumber }}
            </td>
            <td>
              {{ $t(item.orderType) }}
            </td>
            <td>
              {{ item.ordererResponseDto.firstName }} {{ item.ordererResponseDto.lastname }}
            </td>
            <td>
              {{ item.storeName }}
            </td>
            <td>
              {{ item.paidAmount }}€ / {{ item.price }}€
            </td>
            <td>
              +{{ countryCallingCode[item.ordererResponseDto.countryCode] }} {{ item.ordererResponseDto.telephoneNumber }}
            </td>
            <td>
              <span
                v-for="(value, key) in item.billingAddressDto"
                :key="key"
                v-b-tooltip.hover
                :title="getBillingAddressString(item.billingAddressDto)"
                style="margin-right: 10px"
              >
                <span v-if="key === 'street' || key==='houseNumber'">
                  {{ value }} ...
                </span>
              </span>
            </td>
            <td>
              <span>{{ modifyDate(item.created) }}</span>

            </td>
          </tr>
        </LoadingSpinnerTable>
      </table>
      <div>
        <b-pagination
          v-if="getTotalItemsPartiallyOrders > 15"
          v-model="pageNumber"
          :total-rows="getTotalItemsPartiallyOrders"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-itemi"
          next-class="next-itemi"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
    <OrderItemsByIdToggle
      :order-details="orderDetails"
      @onCancelToggle="onCancelToggle"
    />
    <div
      v-if="isSidebarOpen"
      class="backdrop"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { countryCallingCodes } from '@/countryCodes'
import moment from 'moment'
import OrderItemsByIdToggle from './OrderItemsByIdToggle.vue';
import StoresDropdown from '../StoresDropdown.vue';


export default {
  components: {
    OrderItemsByIdToggle,
    StoresDropdown,
  },
  props: [],
  data() {
    return {
      searchFilterOptions: [
        {
          text: this.$t('ClientName'),
          value: 'ClientName',
        },
        {
          text: this.$t('OrderNumber'),
          value: 'OrderNumber',
        },
      ],
      noSearch: false,
      orderDetails: null,
      isSidebarOpen: false,
      pageNumber: 1,
      pageSize: 15,
      countryCallingCode: countryCallingCodes,
      store: { storeId: null, storeName: 'No filiale', storeGLN: null },
      selectedOrderType: null,
      toggleSearch: 'ClientName',
      searchClient: '',
      searchOrderNumber: '',
      searchOrderNumberId: null,
      searchClientId: null,
      searchId: '',
      arrowCounter: -1,
      enterPressed: false,
      skipWatch: false,
    };
  },
  computed: {
    ...mapGetters([
      'getTotalItemsPartiallyOrders',
      'getPartiallyDeliveredOrders',
      'getFilteredOrdersbyCN',
      'getFilteredOrdersbyON',
      'getAllStoresDropdown',
      'getOrderTypes',
    ]),
    searchInput: {
      get() {
        return this.toggleSearch === 'ClientName' ? this.searchClient : this.searchOrderNumber;
      },
      set(value) {
        if (this.toggleSearch === 'ClientName') {
          this.searchClient = value;
        } else {
          this.searchOrderNumber = value;
        }
      },
    },
    filteredResults() {
      if (this.toggleSearch === 'ClientName') return this.getFilteredOrdersbyCN;
      if (this.toggleSearch === 'OrderNumber') return this.getFilteredOrdersbyON;
      return []
    },
    transformOrderTypes() {
      const allOption = { value: null, text: this.$t('OrderTypeAll'), orderType: 'all' };
      const orderTypes = this.getOrderTypes.map((order) => {
        return {
          value: order.orderType,
          text: this.$t(order.orderType),
          orderType: order.orderType,
        };
      });
      const websiteOrderType = {
        value: 'Website',
        text: 'Website',
        orderType: 'Website',
      };
      return [allOption, ...orderTypes, websiteOrderType];
    },
  },
  watch: {
    toggleSearch(newValue) {
      if (newValue === 'OrderNumber') {
        this.searchClient = '';
        this.searchOrderNumber = '';
      } else if (newValue === 'ClientName') {
        this.searchOrderNumber = '';
        this.searchClient = '';
      }
    },
    pageNumber(value) {
      if (value) {
        this.loadPartiallyOrders({
          storeId: this.store.storeId,
          clientId: this.searchClientId,
          orderNumber: this.searchOrderNumberId,
          salesType: 'Product',
          orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
          pageNumber: value,
          pageSize: this.pageSize,
        });
      }
    },
    selectedOrderType(value) {
      if (value == null && this.searchClient != null && this.searchClient != '') {
        this.loadPartiallyOrders({
          storeId: this.store.storeId,
          clientId: this.searchClientId,
          orderNumber: null,
          salesType: 'Product',
          orderType: null,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      } else if (this.searchClient == '') {
        this.loadPartiallyOrders({
          storeId: this.store.storeId,
          orderNumber: null,
          salesType: 'Product',
          orderType: this.selectedOrderType,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      } else if (this.searchOrderNumber == '') {
        this.loadPartiallyOrders({
          storeId: this.store.storeId,
          clientId: this.searchClientId,
          salesType: 'Product',
          orderType: this.selectedOrderType,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      } else {
        this.loadPartiallyOrders({
          storeId: this.store.storeId,
          clientId: this.searchClientId,
          salesType: 'Product',
          orderType: value,
          orderNumber: null,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      }
    },
    store(value) {
      if (value) {
        this.loadPartiallyOrders({
          storeId: value.storeId,
          clientId: this.searchClientId,
          orderNumber: this.searchOrderNumberId,
          salesType: 'Product',
          orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        });
      }
    },
    searchClient(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.searchByCustomerName(value);
        }
      }, 500);
    },
    searchOrderNumber(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
        } else if (!this.enterPressed) {
          this.searchByOrderNumber({
            orderNumber: value,
            salesType: 'Product',
          });
        }
      }, 500);
    },
  },
  mounted() {
    this.loadPartiallyOrders({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    });
    this.loadAllStoresByDropdown({
      amountOfRecords: 100,
    })
    this.loadOrderTypes();
    this.accountDetails(
      {
        isActive: true,
        bankId: null,
      },
    )
  },
  methods: {
    ...mapActions([
      'loadPartiallyOrders',
      'loadAllStoresByDropdown',
      'searchByOrderNumber',
      'searchByCustomerName',
      'resetOrdersNumbers',
      'resetClientName',
      'loadOrderTypes',
      'loadOrderItemsByOrderId',
      'accountDetails',
      'loadLocationsByStoreId',
    ]),
    displayResult(result) {
      if (this.toggleSearch === 'ClientName') return result.nameToDisplay;
      return result;
    },
    selectResult(result) {
      if (this.toggleSearch === 'ClientName') {
        this.searchByCn(result);
      } else if (this.toggleSearch === 'OrderNumber') {
        this.searchByOn(result);
      }
      this.noSearch = false;
    },
    async searchByCn(value) {
      this.searchClient = value.nameToDisplay;
      this.searchClientId = value.clientId;
      this.noSearch = false;
      await this.loadPartiallyOrders({
        storeId: this.store.storeId,
        clientId: value.clientId,
        orderNumber: null,
        salesType: 'Product',
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    async searchByOn(value) {
      this.searchOrderNumber = value;
      this.searchOrderNumberId = value;
      this.noSearch = false;
      await this.loadPartiallyOrders({
        storeId: this.store.storeId,
        clientId: null,
        orderNumber: value,
        salesType: 'Product',
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
    },
    updateFiliale(newFiliale) {
      this.store = newFiliale;
    },
    loadOrderDetails(value, item) {
      this.isSidebarOpen = true
      this.orderDetails = {
        orderId: item.orderId,
        price: item.price,
        paidAmount: item.paidAmount,
      }
      this.loadOrderItemsByOrderId({
        orderId: value,
      })
      // getLocationsByStoreId
      this.loadLocationsByStoreId({
        object: [item.storeId],
      })
    },
    onCancelToggle() {
      this.isSidebarOpen = false
      this.loadPartiallyOrders({
        storeId: this.store.storeId,
        clientId: this.searchClientId,
        orderNumber: this.searchOrderNumberId,
        salesType: 'Product',
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      });
    },
    getBillingAddressString(billingAddressDto) {
      return Object.values(billingAddressDto).join(' ');
    },
    modifyDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    toggleName(value) {
      this.toggleSearch = value;
      this.searchClient = '';
      this.searchOrderNumber = '';
      this.searchOrderNumberId = null;
      this.searchClientId = null;
      this.removeLists();
    },
    async searchByClientName(value) {
      this.loadPartiallyOrders({
        storeId: this.store.storeId,
        clientId: value.clientId,
        orderNumber: null,
        salesType: 'Product',
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }).then(() => {
        this.skipWatch = true;
        this.searchClient = value.nameToDisplay;
        this.searchClientId = value.clientId;
        this.resetClientName();
      });
    },
    async searchByOrderNumberFilter(value) {
      this.loadPartiallyOrders({
        storeId: this.store.storeId,
        clientId: null,
        orderNumber: value,
        salesType: 'Product',
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }).then(() => {
        this.skipWatch = true;
        this.searchOrderNumber = value;
        this.searchOrderNumberId = value;
        this.resetOrdersNumbers();
      });
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.filteredResults.length - 1) {
        this.arrowCounter++;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    selectHighlighted() {
      if (this.arrowCounter >= 0 && this.filteredResults.length > 0) {
        this.selectResult(this.filteredResults[this.arrowCounter]);
      }
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code === 'Enter') {
        this.enterPressed = true;

        // Check which search filter is active and call the appropriate method
        if (this.toggleSearch === 'ClientName') {
          this.searchByClientName(this.getFilteredOrdersbyCN[this.arrowCounter]);
        } else if (this.toggleSearch === 'OrderNumber') {
          this.searchByOrderNumberFilter(this.getFilteredOrdersbyON[this.arrowCounter]);
        }

        this.arrowCounter = 0;

        setTimeout(() => {
          this.enterPressed = false;
        }, 1000);
      }
    },
    onArrowDownBarcode(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredOrdersbyON.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUpBarcode(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChangedBarcode(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOrderNumberFilter(this.getFilteredOrdersbyON[this.arrowCounter])
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    removeLists() {
      this.resetClientName()
      this.resetOrdersNumbers()
      this.loadPartiallyOrders({
        storeId: this.store.storeId,
        clientId: null,
        orderNumber: null,
        salesType: 'Product',
        orderType: this.selectedOrderType == null ? null : this.selectedOrderType,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      })
      this.searchOrderNumberId = null;
      this.searchClientId = null;
    },
  },
};
</script>

<style scoped lang="scss">
  .custom-selected-input {
    border: 1px solid var(--border-color);
    border-radius: 6px;
    padding: 4px 12px;
    cursor: pointer;
    color: rgb(112, 112, 112);
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0%;
  }
    .team_table td {
      padding: 16px 9px !important;
    }
    .dropdrop {
      display: inline-block;
      overflow: auto;
      position: absolute;
      background: white;
      width: 227px;
      box-shadow: none;
      z-index:3;
    }

    input[name="search-box"] {
        display: block;
        max-width: 500px;
        width: 95%;
        padding: 0.5rem 1rem;
        padding-left: 25px;
    }
    .search-item {
        padding: 5px;
        max-width: 500px;
        width: 100%;
        font-weight: 400;
        color: #82868c;
        font-size: 1rem;
        border-bottom: 1px solid #e8e8e8;
    }
    .active2 {
      font-weight: bold;
      color: $base-color;
    }
    </style>
